import { createAsyncThunk } from '@reduxjs/toolkit';
// ===== MOCK DATA =====
const mockAnalyticsData = {
    visitors: [
        { date: '2025-01-01', value: 150 },
        { date: '2025-01-02', value: 200 },
        { date: '2025-01-03', value: 180 },
        { date: '2025-01-04', value: 250 },
        { date: '2025-01-05', value: 220 },
        { date: '2025-01-06', value: 300 },
        { date: '2025-01-07', value: 280 },
        { date: '2025-01-08', value: 320 },
        { date: '2025-01-09', value: 290 },
        { date: '2025-01-10', value: 350 },
        { date: '2025-01-11', value: 380 },
        { date: '2025-01-12', value: 420 },
        { date: '2025-01-13', value: 390 },
        { date: '2025-01-14', value: 450 },
    ],
    bounceRate: 0.45,
    pageViews: 12340,
    uniqueVisitors: 8750,
    avgSessionDuration: 185,
    devices: [
        { device: 'Desktop', value: 6500, percentage: 65 },
        { device: 'Mobile', value: 2500, percentage: 25 },
        { device: 'Tablet', value: 1000, percentage: 10 },
    ],
    trafficSources: [
        { source: 'Google', value: 4500, percentage: 45 },
        { source: 'Direct', value: 2500, percentage: 25 },
        { source: 'Social', value: 1500, percentage: 15 },
        { source: 'Email', value: 1000, percentage: 10 },
        { source: 'Referral', value: 500, percentage: 5 },
    ],
    topPages: [
        { page: '/dashboard', views: 2500, uniqueViews: 1800 },
        { page: '/analytics', views: 1800, uniqueViews: 1200 },
        { page: '/settings', views: 1200, uniqueViews: 900 },
        { page: '/users', views: 800, uniqueViews: 600 },
        { page: '/docs', views: 600, uniqueViews: 450 },
    ],
    conversions: [
        { source: 'Google', visitors: 4500, conversions: 225, rate: 5.0 },
        { source: 'Direct', visitors: 2500, conversions: 150, rate: 6.0 },
        { source: 'Social', visitors: 1500, conversions: 60, rate: 4.0 },
        { source: 'Email', visitors: 1000, conversions: 80, rate: 8.0 },
        { source: 'Referral', visitors: 500, conversions: 15, rate: 3.0 },
    ],
};
// ===== FETCH ANALYTICS THUNK =====
export const fetchAnalyticsThunk = createAsyncThunk('analytics/fetchAnalytics', async (filters, { rejectWithValue }) => {
    try {
        console.log('📊 Fetching analytics data...', filters);
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 500));
        // For now, return mock data
        // TODO: Replace with actual API call when backend is ready
        console.log('✅ Analytics data fetched successfully (mock)');
        return mockAnalyticsData;
    }
    catch (error) {
        console.error('❌ Analytics fetch error:', error);
        const message = error instanceof Error ? error.message : 'Failed to fetch analytics';
        return rejectWithValue(message);
    }
});
// ===== REFRESH ANALYTICS THUNK =====
export const refreshAnalyticsThunk = createAsyncThunk('analytics/refreshAnalytics', async (_, { rejectWithValue }) => {
    try {
        console.log('🔄 Refreshing analytics data...');
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 300));
        // Add some variation to mock data for refresh
        const refreshedData = {
            ...mockAnalyticsData,
            pageViews: mockAnalyticsData.pageViews + Math.floor(Math.random() * 100),
            uniqueVisitors: mockAnalyticsData.uniqueVisitors + Math.floor(Math.random() * 50),
            visitors: mockAnalyticsData.visitors.map(v => ({
                ...v,
                value: v.value + Math.floor(Math.random() * 20) - 10
            }))
        };
        console.log('✅ Analytics data refreshed successfully (mock)');
        return refreshedData;
    }
    catch (error) {
        console.error('❌ Analytics refresh error:', error);
        const message = error instanceof Error ? error.message : 'Failed to refresh analytics';
        return rejectWithValue(message);
    }
});
// ===== EXPORT MOCK DATA FOR DIRECT USE =====
export { mockAnalyticsData };
